import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Icon from 'components/Icon';

import styles from './styles.module.scss';

const FilterButton = ({ onClick, theme }) => (
	<>
		<button
			type="button"
			onClick={onClick}
			className={cx(styles.button, theme && styles[`theme_${theme}`])}
		>
			<Icon
				icon="filter"
				className={cx(styles.icon, 'pvi-no-styles')}
				useClassName="pvi-no-styles"
			/>
		</button>
	</>
);

FilterButton.propTypes = {
	onClick: PropTypes.func,
	theme: PropTypes.oneOf(['accessible'])
};

FilterButton.defaultProps = {};

export default FilterButton;
